import { render, staticRenderFns } from "./movieLogo.vue?vue&type=template&id=7b4391ca"
import script from "./movieLogo.vue?vue&type=script&lang=js"
export * from "./movieLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports